import React from "react"
import { AppBar, Toolbar, IconButton, Box } from "@mui/material"
import MenuRoundedIcon from "@mui/icons-material/MenuRounded"
import { useNavigate, useLocation } from "react-router-dom"
import { useResponsive } from "src/utils/useResponsive"
import { appBarHeight } from "src/providers/AppProviders"
import { TabletNavigation } from "./TabletNavigation"

interface MobileAppBarProps {
  setOpen: React.Dispatch<React.SetStateAction<boolean>>
}

export const MobileAppBar = ({ setOpen }: MobileAppBarProps) => {
  const navigate = useNavigate()
  const { isMobile } = useResponsive()
  const location = useLocation()

  const hideTabletNavigation = ["/", "/files", "/data-sources", "/help", "/profile"].includes(location.pathname)

  if (!isMobile) {
    return null
  }

  return (
    <>
      <AppBar
        position="fixed"
        sx={{
          backgroundColor: "white",
          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
          height: appBarHeight,
          minHeight: appBarHeight
        }}
      >
        <Toolbar
          sx={{
            px: 4,
            justifyContent: "space-between",
            alignItems: "center",
            height: hideTabletNavigation ? appBarHeight : 29,
            minHeight: { xs: hideTabletNavigation ? appBarHeight : 29, md: appBarHeight }
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Box
              component="button"
              onClick={() => navigate("")}
              sx={{
                border: "none",
                background: "transparent",
                padding: 0,
                cursor: "pointer",
                display: "flex",
                alignItems: "center"
              }}
              aria-label="Go to home page"
            >
              <img
                src={"/exfluency/icons/exfluency-icon.svg"}
                alt=""
                style={{
                  height: hideTabletNavigation ? "39px" : "24px",
                  maxWidth: hideTabletNavigation ? "39px" : "24px",
                  pointerEvents: "none"
                }}
              />
            </Box>
          </Box>

          <IconButton
            edge="end"
            onClick={() => setOpen((prev) => !prev)}
            sx={{
              color: "#01294E",
              "&:hover": {
                backgroundColor: "rgba(1, 41, 78, 0.04)"
              }
            }}
            aria-label="open menu"
          >
            <MenuRoundedIcon sx={{ fontSize: hideTabletNavigation ? "39px" : "20px" }} />
          </IconButton>
        </Toolbar>
        {!hideTabletNavigation && <TabletNavigation />}
      </AppBar>
      {/* Spacer */}
      <Toolbar
        sx={{
          height: appBarHeight,
          minHeight: appBarHeight // don't know why, but it's needed
        }}
      />
    </>
  )
}
